import { useRef } from 'react';
import type { IVtsExhibitor } from '../../../Admin/Exhibitors/Exhibitors';
import type { BoothTrack } from '../../panels';
import styles from '../../BoothOverlay.module.scss?module';

interface MediaSlotProps {
  exhibitor: IVtsExhibitor;
  track: BoothTrack;
}

/**
 * 16:9 media area of the fascia. Premium booths with a video show it (no autoplay); all
 * others show the brand key visual, or the brand name without one. The area is never empty.
 */
export default function MediaSlot({ exhibitor, track }: MediaSlotProps) {
  const videoStarted = useRef(false);
  const showVideo =
    exhibitor.package === 'premium' && !!exhibitor.video_public_link;

  const handlePlay = () => {
    if (!videoStarted.current) {
      videoStarted.current = true;
      track('video_started');
    }
  };

  return (
    <div className={styles.mediaSlot}>
      {showVideo ? (
        <video
          className={styles.mediaVideo}
          src={exhibitor.video_public_link}
          controls
          preload="metadata"
          playsInline
          aria-label={`${exhibitor.name} video`}
          onPlay={handlePlay}
        />
      ) : exhibitor.key_visual_url ? (
        <img
          src={exhibitor.key_visual_url}
          alt={exhibitor.name}
          className={styles.mediaKeyVisual}
          loading="lazy"
        />
      ) : (
        <div className={styles.mediaFallback}>
          <span className={styles.mediaName} aria-hidden="true">
            {exhibitor.name}
          </span>
        </div>
      )}
    </div>
  );
}
